// Import necessary dependencies
import React from 'react';
import { useNavigate } from 'react-router-dom'; // If using React Router

const JoinButton = () => {
  const navigate = useNavigate(); // Hook for navigation

  return (
    <div className="join-button-container">
      {/* Use onClick for navigation */}
      <button className="join-button" onClick={() => navigate('/contact')}>
        Join Our Courses
      </button>
      {/* Uncomment below if using an anchor tag instead */}
      {/* <a href="/coursespage" className="join-button-link">
        Join Our Courses
      </a> */}
      <style>{`
        /* Container styles */
        .join-button-container {
          position: fixed;
          bottom: 10px;
          left: 20px;
        }

        /* Button styles */
        .join-button {
          background: linear-gradient(145deg, #6c63ff, #8c85ff);
          color: white;
          border: none;
          border-radius: 10px;
          padding: 15px 30px;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          text-decoration: none; /* For anchor link consistency */
          display: inline-block; /* Anchor button styling */
        }

        .join-button:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
        }

        .join-button:active {
          transform: scale(0.95);
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
        }

        /* Responsive styles */
        @media (max-width: 768px) {
          .join-button {
            font-size: 14px;
            padding: 10px 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default JoinButton;
